{
    "poolsMicroserviceURL": "https://vuecapacitystafd.azurefd.net/v1/",
    "capacityMicroserviceURL": "https://vuecapacitystafd.azurefd.net/v1/",
    "pageTitleSuffix": ""
}